import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

import { useCommonStyles } from '~/styles/commonStyles';
import { SurveyHelper, HappyScaleType } from '~helpers/SurveyHelper';

interface IHappyScaleDisplayProps {
  length: number;
  selectedValue: number | null;
  scaleType: HappyScaleType;
}

export const HappyScaleResult: React.FC<IHappyScaleDisplayProps> = (props) => {
  const { length, selectedValue, scaleType } = props;

  const { classes: commonClasses } = useCommonStyles();

  return (
    <Stack direction="row" display="inline-flex" className={commonClasses.happyScaleContainer}>
      {Array.from({ length }, (_, i) => i + 1).map((happyIndex) => {
        const isSelected = happyIndex === selectedValue;
        const backgroundColor = SurveyHelper.getHappyScaleBackgroundColor(happyIndex, isSelected, scaleType);

        return (
          <Box
            key={happyIndex}
            className={commonClasses.happyScaleItem}
            sx={{
              backgroundColor,
            }}
          >
            <Typography variant="body1" color={isSelected ? 'inherit' : 'text.disabled'}>
              {happyIndex}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
};
